import PropTypes from 'prop-types';

export const ActionTypes = {
    TRACK_AD_CLICK: '@@telehealth/tracking/TRACK_AD_CLICK',
    TRACK_AD_VIEW: '@@telehealth/tracking/TRACK_AD_VIEW',
    TRACK_DOWNLOAD_BUTTON_CLICK: '@@telehealth/tracking/TRACK_DOWNLOAD_BUTTON_CLICK',
    TRACK_SEND_SMS_BUTTON_CLICK: '@@telehealth/tracking/TRACK_SEND_SMS_BUTTON_CLICK',
    TRACK_MODAL_CLOSE_BUTTON_CLICK: '@@telehealth/tracking/TRACK_MODAL_CLOSE_BUTTON_CLICK',
    TRACK_PHONE_NUMBER_INPUT: '@@telehealth/tracking/TRACK_PHONE_NUMBER_INPUT',
    TRACK_SMS_FAILURE_VIEW: '@@telehealth/tracking/TRACK_SMS_FAILURE_VIEW',
    TRACK_SMS_SUCCESS_VIEW: '@@telehealth/tracking/TRACK_SMS_SUCCESS_VIEW',
    TRACK_PROFILE_VIEW: '@@telehealth/tracking/TRACK_PROFILE_VIEW',
};

export const localizedStringType = {
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
};
